import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-saAccessCategory-lookup',
  templateUrl: './micro-saAccessCategory-lookup.component.html'
})
export class MicroSaAccessCategoryLookupComponent {

  @Input()
  categoryId:any;

  @Input()
  link:boolean = true;
}
